import * as React from 'react';

import { PrintableDocument } from '@rematter/modules/trade/types/scaleTickets';
import { Menu, MenuItem, TouchButton } from '@rematter/ui-web';
import { LucidePrinter } from 'lucide-react';

import { usePrintWithBrowser } from '~/modules/trade/hooks/usePrintWithBrowser';

type PrintDocumentsMenuProps = {
  documents: PrintableDocument[];
  isDisabled?: boolean;
};

//
// ⚛️ ⚛️ ⚛️ PRINT DOCUMENTS MENU ⚛️ ⚛️ ⚛️
//
export const PrintDocumentsMenu = ({
  documents,
  isDisabled,
}: PrintDocumentsMenuProps) => {
  // Data hooks
  const { print, isPrinting } = usePrintWithBrowser();

  // Memoized values
  const menuItems = React.useMemo<MenuItem[]>(
    () =>
      documents.map((doc) => ({
        label: doc.label,
        icon: <LucidePrinter />,
        onAction: () => {
          print({
            documents: [
              {
                documentType: doc.documentType,
                loadId: doc.loadId,
                purchaseOrderId: doc.purchaseOrderId,
                salesOrderId: doc.salesOrderId,
                invoiceId: doc.invoiceId,
              },
            ],
          });
        },
        isDisabled: isPrinting || isDisabled || doc.isDisabled,
      })),
    [documents, isPrinting, isDisabled, print],
  );

  return (
    <Menu
      trigger={
        <TouchButton
          size="xl"
          variant="outline"
          color="neutral"
          className=""
          isDisabled={isDisabled}
          onPress={() => null}
        >
          <LucidePrinter />
        </TouchButton>
      }
      items={menuItems}
      size="xl"
      placement="bottom end"
    />
  );
};
